// Environment Configuration for Web
export const ENV = {
  SUPABASE_URL: 'https://qzmhqiwviyftoppuhkpy.supabase.co',
  SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6bWhxaXd2aXlmdG9wcHVoa3B5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NTY2ODMsImV4cCI6MjA2OTUzMjY4M30.9UvmqvYFWRFoF6p7dEzl6MK_tkXEcw5hIYM7lxtdZ0I',
  SUPABASE_SERVICE_ROLE_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6bWhxaXd2aXlmdG9wcHVoa3B5Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1Mzk1NjY4MywiZXhwIjoyMDY5NTMyNjgzfQ.Eu_3tnkKjyNQPlLcMpVI21nvKLAOHO2bklRx0gkSEmE',
  WHATSAPP_SYSTEM_USER_ID: '879ce3a2-ad29-4953-996b-7d01b77d14d2',
  /** Approved Meta template for alerts outside 24h window */
  APP_ENQUIRY_WA_TEMPLATE: 'service_booking_update',
  APP_ENQUIRY_WA_TEMPLATE_LANG: 'en',
  /** Optional: single-param template with body "{{1}}" for full enquiry text */
  APP_ENQUIRY_WA_DETAIL_TEMPLATE: '',
  OPENAI_API_KEY: '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',
  CRON_SECRET: '68959b499e4f847212dabd09ee02ff0a3742a89ac7a45b98',
};

export const SUPABASE_URL = ENV.SUPABASE_URL;
export const SUPABASE_ANON_KEY = ENV.SUPABASE_ANON_KEY;
export const SUPABASE_SERVICE_ROLE_KEY = ENV.SUPABASE_SERVICE_ROLE_KEY;
export const OPENAI_API_KEY = ENV.OPENAI_API_KEY;
export const CRON_SECRET = ENV.CRON_SECRET;

